// Environment Configuration for Web
export const ENV = {
  SUPABASE_URL: 'https://qzmhqiwviyftoppuhkpy.supabase.co',
  SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6bWhxaXd2aXlmdG9wcHVoa3B5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NTY2ODMsImV4cCI6MjA2OTUzMjY4M30.9UvmqvYFWRFoF6p7dEzl6MK_tkXEcw5hIYM7lxtdZ0I',
  SUPABASE_SERVICE_ROLE_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF6bWhxaXd2aXlmdG9wcHVoa3B5Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1Mzk1NjY4MywiZXhwIjoyMDY5NTMyNjgzfQ.Eu_3tnkKjyNQPlLcMpVI21nvKLAOHO2bklRx0gkSEmE',
  WHATSAPP_SYSTEM_USER_ID: '879ce3a2-ad29-4953-996b-7d01b77d14d2',
  /** Approved Meta template for alerts outside 24h window */
  APP_ENQUIRY_WA_TEMPLATE: 'service_booking_update',
  APP_ENQUIRY_WA_TEMPLATE_LANG: 'en',
  /** Optional: single-param template with body "{{1}}" for full enquiry text */
  APP_ENQUIRY_WA_DETAIL_TEMPLATE: '',
  OPENAI_API_KEY: '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',
  CRON_SECRET: '68959b499e4f847212dabd09ee02ff0a3742a89ac7a45b98',
};

export const SUPABASE_URL = ENV.SUPABASE_URL;
export const SUPABASE_ANON_KEY = ENV.SUPABASE_ANON_KEY;
export const SUPABASE_SERVICE_ROLE_KEY = ENV.SUPABASE_SERVICE_ROLE_KEY;
export const OPENAI_API_KEY = ENV.OPENAI_API_KEY;
export const CRON_SECRET = ENV.CRON_SECRET;

